// extracted by mini-css-extract-plugin
export default {"pureCell":"socialnetwork-info_pureCell__JiOTO","icon":"socialnetwork-info_icon__Id3rl"};